var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 13,
    fill: "#E2F4DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2929 27.7071C16.6834 28.0976 17.3166 28.0976 17.7071 27.7071L24.0711 21.3431C24.4616 20.9526 24.4616 20.3195 24.0711 19.9289C23.6805 19.5384 23.0474 19.5384 22.6569 19.9289L17 25.5858L11.3431 19.9289C10.9526 19.5384 10.3195 19.5384 9.92893 19.9289C9.53841 20.3195 9.53841 20.9526 9.92893 21.3431L16.2929 27.7071ZM16 9L16 27L18 27L18 9L16 9Z",
    fill: "#608A51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGreen);
export default __webpack_public_path__ + "static/media/arrowGreen.c85bbb77d9c95b90e2b5fde62b5ec61f.svg";
export { ForwardRef as ReactComponent };